import ConfirmDlg from '@/components/Dialogs/ConfirmDlg.vue';
import AppSignWithQrCodeDialog from '@/sign/components/AppSignWithQrCodeDialog.vue';
import { getLocale } from '@/helpers/locale-helper';
import ChooseActionDlg from '@/components/Dialogs/ChooseActionDlg.vue';

function createDialogCmp(options, Vue, vuetify, dlgComponent, appComponentHtmlElementId) {
  return new Promise(resolve => {
    let appEl = document.getElementById('app');
    if (appEl) {
      let dlgComponentExt = Object.assign(dlgComponent, {
        destroyed: () => {
          if (appEl) {
            el = document.getElementById(appComponentHtmlElementId);
            appEl.removeChild(el);
          }
        }
      });
      let DlgComponentExtConstructor = Vue.extend(dlgComponentExt);
      let onResult = res => resolve(res);
      let cmp = new DlgComponentExtConstructor({ propsData: Object.assign({}, options, { onResult }), vuetify }).$mount();
      let el = appEl.appendChild(cmp.$el);
      el.id = appComponentHtmlElementId;
    }
  });
}

function showConfirmWrapper(Vue, vuetify) {
  return function(
    msg: String, title: String, doNotTranslate: Boolean, width: string, translatePrms: Object,
    buttonYesText: string = '', buttonNoText: string = '', buttonYesColor: string = '', buttonNoColor: string = '') {
    let confirmMsg = msg || 'confirmDialog.default.message';
    let confirmTitle = title || 'confirmDialog.default.title';
    let translatedTitle = doNotTranslate && title ? title : getLocale(confirmTitle, translatePrms);
    let translatedText = doNotTranslate && msg ? msg : getLocale(confirmMsg, translatePrms);
    let options = {};
    options['message'] = translatedText;
    options['title'] = translatedTitle;
    if (width) {
      options['width'] = width;
    }
    if (buttonYesText) options['buttonYesText'] = buttonYesText;
    if (buttonNoText) options['buttonNoText'] = buttonNoText;
    if (buttonYesColor) options['buttonYesColor'] = buttonYesColor;
    if (buttonNoColor) options['buttonNoColor'] = buttonNoColor;

    return createDialogCmp(options, Vue, vuetify, ConfirmDlg, 'appAlertDialog');
  };
}

function showAlertWrapper(Vue, vuetify) {
  return function(msg: String, title: String, doNotTranslate: Boolean) {
    let alertMsg = doNotTranslate ? msg : msg ? getLocale(msg) : '';
    let confirmTitle = getLocale(title || 'alertDialog.default.title');
    return createDialogCmp({
      showYesBtn: false,
      buttonNoText: 'buttons.close',
      message: alertMsg,
      title: confirmTitle
    }, Vue, vuetify, ConfirmDlg, 'appAlertDialog');
  };
}

function showSignWithQrCodeDialogWrapper(Vue, vuetify) {
  return function(options: {}) {
    return createDialogCmp(options, Vue, vuetify, AppSignWithQrCodeDialog, 'appSignWithQrCodeDialog');
  };
}

export interface IActionSelectorItem {
  id: string;
  text: string;
}

function showActionSelectorWrapper(Vue, vuetify) {
  return function(actions: Array<IActionSelectorItem>) {
    return createDialogCmp({ actions }, Vue, vuetify, ChooseActionDlg, 'appActionSelectorDialog');
  };
}

export var showConfirm;

export var showAlert;

export var showSignWithQrCodeDialog;

export var showActionSelector;

export default {
  install(Vue, { vuetify }) {
    Vue.prototype.showConfirm = showConfirm = showConfirmWrapper(Vue, vuetify);

    Vue.prototype.showAlert = showAlert = showAlertWrapper(Vue, vuetify);

    showSignWithQrCodeDialog = showSignWithQrCodeDialogWrapper(Vue, vuetify);

    Vue.prototype.showActionSelector = showActionSelector = showActionSelectorWrapper(Vue, vuetify);
  }
};
